export default __webpack_public_path__ + "static/media/logo_footer.bd17ec5e.png";